import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ThemeState = {
  openDrawer: true,
};

const toggleDrawer: CaseReducer<ThemeState, PayloadAction<boolean>> = (state, action) => {
  state.openDrawer = action.payload;
};

const uiSlide = createSlice({
  name: 'uiSlide',
  initialState,
  reducers: {
    toggleDrawer,
  },
});

export const uiActions = uiSlide.actions;

export default uiSlide.reducer;
